import { createStyles } from '@/styles/theme/utils';

export const headerStyles = createStyles({
   container: {
      h: 'full',
      px: '12',
      '@media (max-width: 767px)': {
         px: '6',
      },
   },
   nav: {
      h: 'full',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: '100px',
   },
   imageBox: {
      w: '78px',
      h: '22px',
      pos: 'relative',
   },
   menuRoot: {
      h: '46px',
      borderRadius: '100px',
      w: '78px',
      bg: 'white',
      borderColor: 'white',
      _hover: {
         bg: 'brand',
         borderColor: 'brand',
      },
      _open: {
         bg: 'brand',
         borderColor: 'brand',
         '& .bar': {
            transform: 'translateX(4px)',
            transition: 'all 0.3s',
         },
         '& .barLine_1': {
            transform: 'rotate(45deg) translateY(4px)',
            transition: 'all 0.3s',
         },
         '& .barLine_2': {
            transform: 'rotate(-45deg) translateY(-5px)',
            transition: 'all 0.3s',
         },
      },
      _closed: {
         transition: 'all 0.3s',
      },
   },
   menuContent: {
      bg: 'brand',
      borderRadius: '3xl',
      p: '6',
      w: '56',
   },
   menuItem: {
      p: '0',
      textTransform: 'uppercase',
      _notLast: { mb: '4' },
      fontWeight: 'semibold',
      fontSize: 'md',
      _hover: { bg: 'transparent', _after: { width: 'full' } },
      cursor: 'pointer',
      position: 'relative',
      _after: {
         content: '""',
         position: 'absolute',
         bottom: '0',
         left: '0',
         width: '0',
         height: '2px',
         bg: 'primary',
         transition: 'width 0.5s ease-in-out',
      },
   },
   header_login_btn: {
      padding: '0',
      height: '46px',
      width: '72px',
      borderRadius: '100px',
      fontWeight: '600',
      bg: 'white',
      _hover: {
         bg: 'brand',
      },
   },
   login_dropdown: {
      position: 'absolute',
      w: '320px',
      p: '40px 30px',
      borderRadius: '30px',
      bg: 'background',
      right: '0',
      top: '50px',
      zIndex: '99',
   },
   login_dropdown_menu: {
      borderBottom: '1px solid #e0e0e045',
      '&:last-child': {
         borderBottom: 'none',
      },
   },
});
